import styled, { keyframes } from "styled-components";
import { Wrapper } from 'AppReact';

const confettiAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const template = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: -27px;
  animation: 1.5s ${confettiAnimation} ease-out;
`;

export default Wrapper(template);